import { Loader2 } from "lucide-react";

export function ChatMessages({ msgs, sending, listRef }) {
  return (
    <div ref={listRef} className="flex-1 overflow-y-auto no-scrollbar p-4 space-y-3">
      {msgs.map((m, i) => (
        <div
          key={m.id || `${m.role}-${i}`}
          data-testid={`chat-msg-${m.role}-${i}`}
          className={`max-w-[85%] text-sm leading-relaxed ${
            m.role === "user"
              ? "ml-auto bg-[color:var(--bl-blue)] text-black px-3 py-2"
              : "bg-white/5 border border-white/8 text-white/85 px-3 py-2"
          }`}
        >
          {m.text}
        </div>
      ))}
      {sending && (
        <div className="bg-white/5 border border-white/8 text-white/60 px-3 py-2 max-w-[85%] inline-flex items-center gap-2 text-sm">
          <Loader2 size={13} className="animate-spin" /> thinking…
        </div>
      )}
    </div>
  );
}
